$(document).ready(function(){
	var contentSection = $('.content-section');
	var navigation = $('nav').not('.nav-desktop');
	
	//when a nav link is clicked, smooth scroll to the section
	navigation.on('click', 'a', function(event){
		event.preventDefault(); //prevents previous event
		smoothScroll($(this).attr('data-group'));
	});
	
	//update navigation on scroll...
	$(window).on('scroll', function(){
		updateNavigation();
	})
	//...and when the page starts
	updateNavigation();
	
	/////FUNCTIONS
	function updateNavigation(){
		contentSection.each(function(){
			var sectionName = $(this).attr('data-group');
			var navigationMatch = $('nav a[data-group="' + sectionName + '"]');
			if( ($(this).offset().top - $(window).height()/2 < $(window).scrollTop()) &&
				  ($(this).offset().top + $(this).height() - $(window).height()/2 > $(window).scrollTop()))
				{
					navigationMatch.addClass('active-section');
				}
			else {
				navigationMatch.removeClass('active-section');
			}
		});
	}
	function smoothScroll(target){
		$('body,html').animate({
			scrollTop: $(`.content-section[data-group='${target}']`).eq(0).offset().top
		}, 800);
	}
});